<div class="modal-container">
    <div class="modal-title">
        Atenci&oacute;n
    </div>
    <div class="modal-message mt-3">
        {{message}}
    </div>

    <div class="action-container mt-4">
        <div class="btn btn-secondary padding-fix cancel-btn" (click)="close()">
            Cancelar
        </div>

        <div class="btn btn-danger padding-fix cancel-btn" (click)="continue()">
            Aceptar
        </div>
    </div>
</div>
